// extracted by mini-css-extract-plugin
export var skipAnimation = "_43-0";